import { render } from "./BaseContainer.vue?vue&type=template&id=07d33436"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=07d33436&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\vue-form\\vue-form\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__